/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Section_DocsInputs */

const en_vault_section_docs = /** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure Files & Documents`)
};

const id_vault_section_docs = /** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File & Dokumen Aman`)
};

/** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */
const es_vault_section_docs = en_vault_section_docs;

/** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */
const fr_vault_section_docs = en_vault_section_docs;

/** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */
const de_vault_section_docs = en_vault_section_docs;

/** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */
const ja_vault_section_docs = en_vault_section_docs;

/** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */
const zh_vault_section_docs = en_vault_section_docs;

/** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */
const ar_vault_section_docs = en_vault_section_docs;

/** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */
const it_vault_section_docs = en_vault_section_docs;

/** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */
const ru_vault_section_docs = en_vault_section_docs;

/** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */
const pt_vault_section_docs = en_vault_section_docs;

/** @type {(inputs: Vault_Section_DocsInputs) => LocalizedString} */
const ko_vault_section_docs = en_vault_section_docs;

/**
* | output |
* | --- |
* | "Secure Files & Documents" |
*
* @param {Vault_Section_DocsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_section_docs = /** @type {((inputs?: Vault_Section_DocsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Section_DocsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_section_docs(inputs)
	if (locale === "es") return es_vault_section_docs(inputs)
	if (locale === "fr") return fr_vault_section_docs(inputs)
	if (locale === "de") return de_vault_section_docs(inputs)
	if (locale === "ja") return ja_vault_section_docs(inputs)
	if (locale === "zh") return zh_vault_section_docs(inputs)
	if (locale === "ar") return ar_vault_section_docs(inputs)
	if (locale === "id") return id_vault_section_docs(inputs)
	if (locale === "it") return it_vault_section_docs(inputs)
	if (locale === "ru") return ru_vault_section_docs(inputs)
	if (locale === "pt") return pt_vault_section_docs(inputs)
	return ko_vault_section_docs(inputs)
});